<template>
	<div>
		<div class="footBox f-ct">
			<div class="conBox">
				<!-- Ссылки друзей -->
				<div class="fLink">
					<div class="itm">Группа Алибаба</div>
					<div class="itm">Таобао</div>
					<div class="itm">Т-молл</div>
					<div class="itm"> Международный торговый рынок Алибаба</div>
					<div class="itm">1688</div>
					<div class="itm">Алибаба Мама</div>
					<div class="itm">Фэйжу (Флигг)</div>
					<div class="itm">Алибаба Клауд (Алибаба Облачные вычисления)</div>
					<div class="itm">YunOS</div>
					<div class="itm">Алипэй (Alipay)</div>
					<div class="itm">UC</div>
					<div class="itm">Дингдинг (DingTalk)</div>
				</div>
				<div class="t1">Уведомление о копирайте阿里钉钉C ©2015-2525 Все права защищены компанией Логистика (Китай) Информационные технологии и/или ее аффилированными компаниями. Регистрация Zhejiang ICP: 18037475-4</div>
				<div class="t2 f-ct">
					<el-image :src="require('@/static/icon9.png')"></el-image>
					<span>Защита сетей Zhejiang: 330110020213770</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Foot",
	data(){
		return {
			
		}
	},
	mounted() {
		
	},
	methods:{
		
	}
}
</script>
<style lang="scss">
body{
	background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.footBox{
	width: 100%;
	padding: 44px 0;
	// height: 170px;
	background: #252E37;
	color: #fff;
	.conBox{
		width: 1560px;
		margin: auto;
		.fLink{
			display: flex;
			align-items: center;
			justify-content: center;
			.itm{
				padding: 0 6px;
				font-size: 14px;
				color: #fff;
				border-right: 1px solid #FFFFFF99;
				&:last-child{
					border: none;
				}
			}
		}
		.t1{
			font-size: 14px;
			color: #FFFFFF99;
			margin-top: 9px;
			text-align: center;
		}
		.t2{
			justify-content: center;
			margin-top: 9px;
			.el-image{
				width: 24px;
				margin-right: 6px;
			}
			span{
				font-size: 14px;
				color: #FFFFFF99;
			}
		}
	}
}
</style>